import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { clearAllExceptAccount } from "src/store/actions";
import GarageSettingsMenu from "./GarageSettingsMenu";

function mapStateToProps({ account, deal, onlineShopper }: ApplicationStore) {
    return {
        env: onlineShopper.env,
        slug: account.slug,
        uuid: deal.uuid as string,
    };
}

const mapDispatchToProps = (dispatch: any) => ({
    clearAll: () => dispatch(clearAllExceptAccount()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GarageSettingsMenu);
